import { useEffect, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkUser } from "../http/http";



 const AuthGuard = ({ children }) => {
  const location = useLocation();

  const params = useParams();

  if(params.msisdn){
    localStorage.setItem("mobile",params.msisdn)
  }
 
  const user = useSelector((state) => state.user);

const reduxMsisdn = user?.msisdn;

const msisdn = localStorage.getItem("msisdn") || localStorage.getItem("mobile") || params.msisdn|| reduxMsisdn ;

console.log(msisdn,"msisdn---") 
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const checkAuthentication = async () => {
   
      if (!msisdn) {
        setAuthorized(false);
        setLoading(false);
        return;
      }

      try {

    const payload = {
      msisdn,
    };
        console.log("Checking user:", msisdn);

        const data = await checkUser(payload);

        console.log("Check User Response==================:", data?.data?.active );

      
        setAuthorized(data.data?.active);

      } catch (error) {
        console.error("Check user error:", error);
        setAuthorized(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuthentication();
  }, [msisdn]);

     if (loading) {
     return null;
   }
  console.log(authorized,"----------------------")

  if (!authorized) {
    console.log('not authorized=========================') 
    return (
      <Navigate
        to="/"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  console.log('authorized========================')

  return children;
};

export default AuthGuard;